module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPurchasePrice),
      expression: "newPurchasePrice"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "step": "any",
      "min": "0"
    },
    domProps: {
      "value": (_vm.newPurchasePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPurchasePrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])])])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.currentPurchasePrice) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v("€ " + _vm._s(_vm.currentPurchasePrice))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-991a0b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/PurchasePriceEditable.vue
// module id = 745
// module chunks = 1